{
  "version": 1,
  "asset_id": "174da8da-3292-48a0-b090-b6fe63221733",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/174da8da-3292-48a0-b090-b6fe63221733/suspension-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/174da8da-3292-48a0-b090-b6fe63221733/suspension-thumb.webp",
  "original_filename": "suspension-thumb.webp",
  "size": 6856,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:24Z"
}
